/**
 * Date Filter
 * Date range filtering logic
 */

import { state } from '../core/state.js';
import { dateYmdToInt } from '../utils/date-utils.js';

/**
 * Get date filter for camp matching.
 * Returns null if no date filters selected, or { startDay, endDay } as YYYYMMDD integers.
 * @returns {Object|null} - { startDay, endDay } or null
 */
export function getDateFilter() {
  if (!state.beginDates || !state.endDates) return null;
  const startDay = dateYmdToInt(state.beginDates);
  const endDay = dateYmdToInt(state.endDates);
  if (!startDay || !endDay) return null;
  return { startDay, endDay };
}

/**
 * @deprecated Use getDateFilter() instead
 */
export function getDateRangeTimestamps() {
  return getDateFilter();
}

/**
 * Check if camp matches date filter using sessionStartDays.
 * Returns true if:
 * - No date filter applied
 * - Camp has no sessionStartDays (no date data — always include)
 * - Any session start day falls within the selected range
 * @param {Object} camp - Camp object from Algolia
 * @param {Object|null} dateFilter - { startDay, endDay } as YYYYMMDD integers
 * @returns {boolean}
 */
export function campMatchesDateFilter(camp, dateFilter) {
  if (!dateFilter) return true; // No date filter applied

  const { startDay, endDay } = dateFilter;

  // Include camps without sessionStartDays (no date info)
  if (!camp.sessionStartDays?.length) return true;

  // Include camps where any session starts within the selected range
  return camp.sessionStartDays.some((d) => d >= startDay && d <= endDay);
}

console.log('📦 Date filter module loaded');
